export const ToolBox = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12C3 10.8954 3.89543 10 5 10H27C28.1046 10 29 10.8954 29 12V26C29 26.5523 28.5523 27 28 27H4C3.44772 27 3 26.5523 3 26V12Z" stroke="currentColor" stroke-width="2"/>
<path d="M23 10V6C23 5.44772 22.5523 5 22 5H10C9.44772 5 9 5.44772 9 6V10" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M3 16H29" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M13 16V21H19V16" stroke="currentColor" stroke-width="2"/>
</svg>`;
